/*
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-09-22 19:03:12
 */
/* eslint-disable */
import fetchHelper from '../utils/fetchHelper'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'

// 获取成员实时位置数据
export function fetchRealtimeLocationData(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/location/realtime/v1',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 设置设备定位开关配置
export function setLocationConfigData(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/location/realtime/config',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

// 查询设备定位开关配置信息
export function fetchLocationConfigData(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/location/realtime/config/query',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}
